import type { I18n, LocalizedText } from '@optionway/models';

// A text read in one language comes as is; a set of translations is read in the current locale.
export const useLocalized = (i18n?: LocalizedText | I18n): ComputedRef<string | undefined> => {
  const { locale } = useI18n();
  return computed(() => {
    if (i18n && 'text' in i18n) {
      return i18n.text;
    }
    return i18n ? (i18n.locale[locale.value] ?? i18n.locale[i18n.default]) : undefined;
  });
};
